import React from "react";
import { useInstantSearch, usePagination } from "react-instantsearch";
import { PaginationComponent } from "../components/inputs/PaginationComponent";

export const DocumentPagination = ({ pageSize = 20 }) => {
  const { currentRefinement: page, nbPages: pages, isFirstPage, isLastPage, refine } = usePagination();

  const { status } = useInstantSearch();

  const loading = status === "loading";
  const canPrevious = !isFirstPage;
  const canNext = !isLastPage;

  const onPageChange = (newPage) => {
    refine(newPage);
  };

  return (
    <PaginationComponent
      page={page}
      pages={pages}
      loading={loading}
      pageSize={pageSize}
      showPageJump={true}
      canPrevious={canPrevious}
      canNext={canNext}
      onPageChange={onPageChange}
    />
  );
};
